import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils';
    import { DialogOverlay, type DialogOverlayProps } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DialogOverlay',
  props: {
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DialogOverlay), _mergeProps({ "data-slot": "dialog-overlay" }, delegatedProps.value, {
    class: 
            _unref(cn)(
                'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-modal-overlay/50 fixed inset-0 z-50',
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})